
/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FavoriteColorResponse,
} from '../models';
import {
    FavoriteColorResponseFromJSON,
    FavoriteColorResponseToJSON,
} from '../models';

/**
 * 
 */
export class JulieOnboardingApi extends runtime.BaseAPI {

    /**
          */
    async getFavoriteColorRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FavoriteColorResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FavoriteColorResponse>({
            path: `/cms/api/onboarding/julie/favorite-color`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FavoriteColorResponseFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getFavoriteColor(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FavoriteColorResponse> {
        const response = await this.getFavoriteColorRaw(initOverrides);
        return response._data;
    }

}
